//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("payments", PaymentsFactory);

    PaymentsFactory.$inject = ["apiClientFactory"];
    function PaymentsFactory(apiClientFactory) {

        const routePrefix = "api/Payments/";

        return {
            ChangeStructuredMessage: apiClientFactory.patch(routePrefix + "ChangeStructuredMessage/"),
            Delete: apiClientFactory.patch(routePrefix),
            DeleteUploads: apiClientFactory.patch(routePrefix + "Uploads/"),
            GetInvoicePaymentsToValidate: apiClientFactory.get(routePrefix),
            GetUploads: apiClientFactory.post(routePrefix + "Uploads/"),
            Validate: apiClientFactory.patch(routePrefix + "Validate/"),
        };
    }
})();
